import { render } from "./ImageGallery.vue?vue&type=template&id=7e4af91c"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__